import React from 'react';
import ChartBuilderDataSourcesSelect from './ChartBuilderDataSourcesSelect';
import ChartBuilderSourceColumnsSelect from './ChartBuilderSourceColumnsSelect';
import ChartBuilderSegmentingOptions from './ChartBuilderSegmentingOptions';
import Colorpicker from '../Colorpicker/Colorpicker';

export default class ChartBuilderDataDetail extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return(
      <div key={this.props.detail.id}>
          <div className="row">
            {this.renderDataSources()}
            {this.renderDataSourceColumns()}
            {this.renderSegmentOptions()}
            {this.renderDetailColor()}
            {this.renderDetailDataType()}
            <div className="col content-right flexed" style={{ margin: 'auto' }}>
              <button type="button" name={this.props.detail.id} className="btn btn-secondary btn-sm" style={{ paddingLeft: '7px', paddingRight: '7px', margin:'.25rem' }} onClick={this.props.onRemoveSecondaryAxisDetail}>{I18n.t('remove')}</button>
              <button type="button" name={this.props.detail.id} className="btn btn-secondary btn-sm" style={{ paddingLeft: '7px', paddingRight: '7px', margin: '.25rem' }} onClick={this.props.onDuplicateSecondaryAxisDetail}>{I18n.t('duplicate')}</button>
            </div>
          </div>
      </div>
    );
  };

  renderDataSources(){
    return (
      <div className="col-md-3">
        <div className="form-group">
          <label style={{ display: 'block' }}>{`${I18n.t('data_source')}`}</label>
          <ChartBuilderDataSourcesSelect
            error={this.fieldErrors('Data Source')}
            detail={this.props.detail}
            dataSources={this.dataSources()}
            onChangeDataDetailDataSource={this.props.onChangeDataDetailDataSource}
          />
        </div>
      </div>
    );
  };

  renderDataSourceColumns(){
    if(this.props.detail.data_source){
      var columnSources = this.props.detail.data_source.source_details.filter(sd => sd.data_type !== this.props.primaryAxisDetail.data_type);
      return (
        <div className="col-md-3">
          <div className="form-group">
            <label >{`${I18n.t('columns_data_type')}*`}</label>
            <ChartBuilderSourceColumnsSelect
              error={this.fieldErrors('Columns')}
              detail={this.props.detail}
              columns={columnSources}
              externalData={this.props.detail.data_source.system_data ? false :  true}
              onChangeDataDetailColumn={this.props.onChangeDataDetailColumn}
              primaryDetail={false}
            />
          </div>
        </div>
      );
    };
  };

  renderSegmentOptions(){
    if (this.props.detail.data_source && this.props.detail.source_detail && this.props.detail.source_detail.segment_on_model){
      return(
        <div className="col-md-2">
          <div className="form-group">
            <label>{`${I18n.t(this.camelToSnakeCase(this.props.detail.source_detail.segment_on_model))}*`}</label>
            <ChartBuilderSegmentingOptions
              error={this.fieldErrors('Select')}
              dataDetail={this.props.detail}
              onChange={this.props.onAddSegmentOn}
              // onUnChecked={this.props.removeSegmentOn}
              segmentModel={this.props.detail.source_detail.segment_on_model}
              segmentColumn={this.props.detail.source_detail.segment_on_column}
              dataSourceId={this.props.detail.data_source.id}
              selectAll={false}
            />
          </div>
        </div>
      );
    };
  };

  renderDetailColor(){
    if (this.props.detail.data_source && this.props.detail.data_column_name){
      if (this.props.detail.data_column_name.includes('relevant')){
        var palettes = Object.keys(this.props.colorPalettes)
        return(
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('palette')}`}</label>
              {
                palettes.map(cp => {
                  return (
                    <div key={cp}>
                      <input
                        type="radio"
                        value={cp}
                        checked={this.props.detail.color === cp ? true : false}
                        onChange={this.props.onChangeColor}
                        name={this.props.detail.id}
                      />
                      <div style={{ display: 'inline-block', marginLeft: '10px' }}>
                        {
                          this.props.colorPalettes[cp].map(color => {
                            return <span key={color} style={{ marginRight: '3px' }}><Colorpicker name={color} color={color} read_only={true} width={15} height={15} /></span>
                          })
                        }
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        )
      } else {
        return(
          <div className="col-md-1">
            <label style={{ display: 'block' }}>{`${I18n.t('color')}*`}</label>
            <Colorpicker name={this.props.detail.id} color={this.props.detail.color} onChange={this.props.onChangeColor} error={this.fieldErrors('Color')}/>
          </div>
        );
      };
    };
  };

  renderDetailDataType(){
    if (this.props.detail.data_source && this.props.detail.data_column_name && this.props.detail.data_type) {
      return (
        <div className="col-md-1">
          <label style={{ display: 'block' }}>{`${I18n.t('data_type')}*`}</label>
          <p className={this.fieldErrors('Data Types') ? 'has-errors' : ''}>
            {I18n.t(this.props.detail.data_type)}
          </p>
          {
            this.fieldErrors('Data Types')
              ?
              <div className="help-block">
                <ul>{I18n.t('types_must_match')}</ul>
              </div>
              :
              null
          }
        </div>
      );
    };
  };

  dataSources(){
    if(this.props.report_details.chart_type.name === 'vertical_bar_chart' || this.props.report_details.chart_type.name === 'horizontal_bar_chart'){
      return (this.props.dataSources.filter(ds => ds.id === this.props.primaryAxisDetail.data_source.id))
    }else{
      return this.props.dataSources
    }
  }

  fieldErrors(field) {
    var fieldError = false
    this.props.errors.forEach((error) => {
      if (error.includes(field)) {
        fieldError = true
      };
    });
    return fieldError
  };

  camelToSnakeCase (str){
    return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).substr(1);
  };

};